<div matDialogTitle>Giltig e-postadress saknas</div>

<mat-dialog-content>
  Du behöver lägga till en giltig e-postadress till ditt konto.
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="edit()">
      Redigera dina uppgifter
    </button>
</mat-dialog-actions>